import { ComponentFactoryResolver, ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { DynamicComponentRegistryService } from './dynamic-component-registry.service';
import { IDynamicComponent } from './interfaces';

@Injectable()
export class DynamicComponentFactoryService {

  constructor(
    private registry: DynamicComponentRegistryService,
    private resolver: ComponentFactoryResolver
  ) {
  }

  createByType(container: ViewContainerRef, componentType: Type<any>): ComponentRef<IDynamicComponent> {
    const componentFactory = this.resolver
      .resolveComponentFactory<any>(componentType);
    return container.createComponent(componentFactory);
  }

  createByName(container: ViewContainerRef, typeName: string): ComponentRef<IDynamicComponent> {
    if (!this.registry.has(typeName)) {
      console.warn(`dcf: No component for type "${typeName}"`);
    }

    const componentClass = this.registry.getType(typeName) as any;
    const componentFactory = this.resolver.resolveComponentFactory<IDynamicComponent>(componentClass);
    return container.createComponent(componentFactory);
  }
}
